import { useEffect, useRef } from 'preact/hooks';

/** Échap appelle `onBack` même quand le focus est tombé sur le fond ; un seul écouteur sur `document`, retiré au démontage. */
export function useEscape(onBack: () => void): void {
  const back = useRef(onBack);
  back.current = onBack;
  useEffect(() => {
    const onEscape = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.preventDefault(); back.current(); } };
    document.addEventListener('keydown', onEscape);
    return () => document.removeEventListener('keydown', onEscape);
  }, []);
}
